import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import List from '@/assets/common/List/List.vue'
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';


type Material = {
    id: string;
    name: string;
    memo: string;
    type: "DEPRECIATION_TIMES" | "DEPRECIATION_USES" | "EXPENDABLE";
    isHidden: boolean;
    isEditable: boolean;
}

type MaterialsGet = {
    materials: Material[];
}

@Component({
    components: {
        List
    }
})
export default class Materials extends Vue {
    private list: any | null = null
    private title = '資材'
    private baseUrl = '/materials';
    private clientBaseUrl = '/master/materials'
    private materials: Material[] = []
    private withHidden = false
    private isLoading = false
    private headerTitle!: string
    private selectedMaterial!: Material
    private materialId = ""
    private materialName = ""
    private materialMemo = ""
    private materialType: "DEPRECIATION_TIMES" | "DEPRECIATION_USES" | "EXPENDABLE" = "EXPENDABLE"
    private isHidden = false
    private isEditable = true

    @Prop()
    private id!: string

    private created() {
        this.getMaterials(false)
    }

    private getMaterials(withHidden: boolean) {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?type=ALL&with_hidden=${withHidden}`).then(ret => {
            this.materials = (toCamel(ret) as MaterialsGet).materials as Material[]
        })
        .finally(() => {
            this.list = List
            this.isLoading = false
        })
    }

    private createMaterials() {
        this.$router.push(`${this.clientBaseUrl}/`, () => {return})
        if(store.getters.isInputChanged==false){
        this.headerTitle = "新規資材"
        this.materialId = "create"
        this.materialName = ""
        this.materialMemo = ""
        this.materialType = "EXPENDABLE"
        this.isHidden = false
        this.isEditable = true
        }
    }

    private toggleHiddenItems(value: boolean) {
        this.withHidden = value;
        this.getMaterials(this.withHidden)
    }

    private setMaterials(materialId: string) {
        this.headerTitle = "資材情報"
        this.$router.push(`${this.clientBaseUrl}/${materialId}`, () => {return})
        if(store.getters.isInputChanged==false){
        this.$apiClient.doRequest("get", `${this.baseUrl}/${materialId}`).then((ret) => {
            const item = this.selectedMaterial = toCamel(ret) as Material
            this.materialId = item.id
            this.materialName = item.name
            this.materialMemo = item.memo
            this.materialType = item.type
            this.isHidden = item.isHidden
            this.isEditable = item.isEditable
        })
    }
    }

    private switchDisplay() {
        if (!window.confirm(`${this.selectedMaterial.name}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか。`)){
            return
        }

        this.isLoading = true

        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.materialId}/display?is_hidden=${!this.isHidden}`).then(() => {
            this.isHidden = !this.isHidden;
            if(this.isHidden) {
                this.$router.push(this.clientBaseUrl, () => {return});
            } else {
                this.$router.push(`${this.clientBaseUrl}/${this.materialId}`, () => {return});
            }
            this.getMaterials(this.withHidden)
            this.$toasted.success('変更を保存しました。')
        })
        .catch(() => {
            this.$toasted.error('変更に失敗しました。')
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private cancelEdit() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if(this.materialId !== 'create') {
            this.setMaterials(this.materialId)
        } else {
            this.createMaterials()
        }
    }

    private submit() {
        const errmsg: string[] = []
        // 名前の入力
        if(!this.materialName.trim()) {
            errmsg.push("資材名を入力してください")
        }
        // 名前の長さ
        if(this.materialName.length > 100) {
            errmsg.push(`資材名は100文字以内で入力してください（現在は${this.materialName.length}文字）`)
        }
        // メモ
        if(this.materialMemo && this.materialMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.materialMemo.length}文字）`)
        }
        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        this.isLoading = true
        const params = {
            name: this.materialName,
            memo: this.materialMemo,
            type: this.materialType
        }

        if (this.materialId === "create") {
            this.$apiClient.doRequest("post", `${this.baseUrl}`, params).then((ret) => {
                this.$router.push(`${this.clientBaseUrl}/${ret.id}`, () => {return})
                this.getMaterials(this.withHidden)
                this.$toasted.success('保存しました。')
            })
            .catch(() => {
                this.$toasted.error('保存に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                this.isLoading = false
                return false;
            }
            this.$apiClient.doRequest("put", `${this.baseUrl}/${this.materialId}`, params).then(() => {
                this.getMaterials(this.withHidden)
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
            .finally(() => {
                this.isLoading = false
            })
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }
}

